import { setAcceptGroup, getCategories, getSettings, ALL_CATEGORIES } from "../lib/cookie-consent";
import { getString } from "../lib/localization";

class CookieSettings extends HTMLElement {

   static NOTIFICATION_SUCCESS = "success";
   static NOTIFICATION_ERROR = "error";
   static NOTIFICATION_NOTICE = "notice";
   static NOTIFICATION_WARNING = "warning";

   notifications = {};

   allAccepted = false;
   checkboxes = {};
   toggleAllCheckbox;
   checkboxContainer;

   constructor() {
      super();

      this.checkboxContainer = document.createElement("div");
      this.appendChild(this.checkboxContainer);

      window.addEventListener("load", () => {
         const categories = getCategories();

         const fragment = document.createDocumentFragment();
         Object.keys(categories).forEach(key => fragment.appendChild(this.renderCategory(key, categories[key])));
         fragment.appendChild(this.renderCategory(ALL_CATEGORIES, {}));
         this.checkboxContainer.appendChild(fragment);
         this.updateCheckboxes();
      });

      const applyButton = document.createElement("button");
      applyButton.className = "button button--primary mt-2";
      applyButton.innerText = getString("cookieSettings.apply");
      applyButton.addEventListener("click", () => this.applySettings());
      this.appendChild(applyButton);
   }

   updateCheckboxes() {
      let settings = getSettings();

      const settingsKeys = settings ? Object.keys(settings) : [];
      let allAccepted = settingsKeys.length > 0;
      settingsKeys.forEach((key) => {
         this.checkboxes[key].checked = settings[key];

         if (!settings[key]) {
            allAccepted = false;
         }
      });

      this.toggleAllCheckbox.checked = allAccepted;
   }

   renderCategory(key, category) {
      const required = category.required || false;

      const element = document.createElement("div");
      element.className = "mb-1";
      const label = document.createElement("label");

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.checked = required;
      checkbox.required = required;
      checkbox.disabled = required;
      checkbox.className = "me-2";

      label.appendChild(checkbox);

      if (key === ALL_CATEGORIES) {
         label.appendChild(document.createTextNode(getString("cookieSettings.toggleAll")));
         checkbox.addEventListener("change", this.toggleAllHandler);
         this.toggleAllCheckbox = checkbox;
      } else {
         label.appendChild(document.createTextNode(category.label));
         checkbox.name = key;
         checkbox.addEventListener("change", this.changeHandler);
         this.checkboxes[key] = checkbox;
      }

      element.appendChild(label);

      return element;
   }

   changeHandler = () => {
      let allChecked = true;
      this.clearNotifications();

      Object.values(this.checkboxes).forEach((checkbox) => {
         if (!checkbox.checked) {
            allChecked = false;
         }
      });

      Object.values(this.checkboxes).forEach((checkbox) => {
         if (!checkbox.required && !checkbox.checked) {
            allChecked = false;
         }
      });

      this.toggleAllCheckbox.checked = allChecked;
   }

   toggleAllHandler = (event) => {
      Object.values(this.checkboxes).forEach((checkbox) => {
         if (!checkbox.required) {
            checkbox.checked = event.currentTarget.checked === true;
         }
      });
   }

   showNotification(message, title = "", type = CookieSettings.NOTIFICATION_NOTICE, time = 0) {
      const key = message + title;
      if (!Object.keys(this.notifications).includes(key)) {
         const element = document.createElement("div");
         element.className = `notification notification--${type} mb-2`;
         element.innerText = message;
         this.notifications[key] = element;
         this.insertBefore(element, this.firstChild);
      }
   }

   clearNotifications() {
      Object.keys(this.notifications).forEach(key => {
         this.notifications[key].parentNode.removeChild(this.notifications[key]);
         delete this.notifications[key];
      });
   }

   applySettings() {
      let checkbox;

      Object.keys(getCategories()).forEach(key => {
         checkbox = this.checkboxes[key];
         if (checkbox) {
            setAcceptGroup(key, checkbox.checked);
         }
      });

      this.showNotification(getString("notification.deleteExistingManually"));

      this.showNotification(
         getString("notification.settingsApplied"),
         "",
         CookieSettings.NOTIFICATION_SUCCESS
      );
   }

}

customElements.define('cookie-settings', CookieSettings);
